import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from 'Components/readonly'
import { SidebarHeader, Spacer } from 'Components/layout'
import { setLocked } from "../../../Utils/functions";
import { useIntl } from 'react-intl'

const ProductSdsPreliminarySidebarHeader = ({ close, skip, productId, setShowClickOutsideError }) => {
  const intl = useIntl();

  return (
    <SidebarHeader>
      <h2>
        <FormattedMessage id="chemicals.register_product_heading"/>
      </h2>
      <Spacer/>
      <div>
        <Button
          label={intl.formatMessage({ id: 'common.cancel' })}
          onClick={() => {
            close();
            setLocked(productId, 0);
          }}
          icon="pi pi-times" className="button-text-md-hide"
        />
        <Button
          id="proceed-button"
          primary
          label={intl.formatMessage({ id: 'common.continue2' })}
          icon="pi pi-check"
          onClick={() => {
            skip()
            setShowClickOutsideError(false);
          }}
          className="button-text-md-hide"
        />
      </div>
    </SidebarHeader>
  )
}

export default ProductSdsPreliminarySidebarHeader
